import React from 'react';
import * as Yup from 'yup';
import v4 from 'uuid';
import { parseDateFromFormats } from '../../../utilities/parseDate';
import axios from 'axios';
import URL from '../../../store/path'
import { debounce } from 'lodash'


export const ledgermap = () => ({
    id: v4(),
    parent_group: "",
    ledger_type: "",
    dms_id: "",
    dms_name: "",
    dms_pan: "",
    dms_gstin: "",
    rlb_id: "",
    rlb_name: "",
    rlb_pan: "",
    rlb_gstin: "",
    segid: null,
    cid: null,
    status: 1,
    uid_create: null,
    uid_update: null,
    dt_create: "",
    dt_update: "",
    dr_msil: "",
    dr_msil_code: "",
    cr_msil: "",
    cr_msil_code: "",
    dler_disc: "",
    dler_disc_code: "",
    control_ldgr: "",
    control_ldgr_code: "",
    msilToggle: "",
    vb_discount_field: null,
    exception_for_tax_computation : 0,

})


Yup.addMethod(Yup.date, 'format', parseDateFromFormats);

// PAN validation: 5 uppercase letters + 4 digits + 1 uppercase letter
const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/

// GSTIN validation: 2 digits + 5 letters + 4 digits + 1 letter + 1 alphanumeric + Z + 1 alphanumeric
const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/

export const ledgermapSchema = Yup.object().shape({

    id: Yup.string()
        .required('This is a Required Field'),
    parent_group: Yup.string()
        .required('Parent Group Required'),

    ledger_type: Yup.string()
        .required('Ledger Type Required'),

    rlb_id: Yup.string()
        .required('Realbooks Ledger Id Required'),
    dms_id: Yup.string()
        .nullable()
        .required('DMS Ledger Id Required'),
    rlb_name: Yup.string()
        .required('Realbooks Ledger Name Required'),
    dms_name: Yup.string()
        .required('DMS Ledger Name Required'),
    dms_pan: Yup.string()
        .nullable()
        .test('pan-format', 'Invalid PAN format (e.g., ABCDE1234F)', function(value) {
            if (!value || value.trim() === '') return true
            return PAN_REGEX.test(value.toUpperCase())
        }),
    dms_gstin: Yup.string()
        .nullable()
        .test('gstin-format', 'Invalid GSTIN format (e.g., 27ABCDE1234F1Z5)', function(value) {
            if (!value || value.trim() === '') return true
            return GSTIN_REGEX.test(value.toUpperCase())
        }),

    status: Yup.number().integer().nullable(),
    txnid: Yup.string().nullable(),
    dt_create: Yup.string().nullable(),
    dt_update: Yup.string().nullable(),
    // user_create: Yup.string().nullable(),
    // user_update: Yup.string().nullable()

});


export const duplicateCheckLedgermapCode = debounce(checkLedgermapCode, 500);
function checkLedgermapCode(value) {
    if (value.length > 0)
        return axios.post(URL + '/ledgermap/exists/' + value, { type: 'checkCode' })
            .then(response => {
                if (response.data === 'duplicate') {
                    console.log("response", response.data)
                    return "Duplicate"
                }
            })
            .catch(error => "")
}


export const duplicateCheckLedgermapName = debounce(checkLedgermapName, 500);
function checkLedgermapName(value) {
    if (value.length > 2)
        return axios.post(URL + '/ledgermap/exists/' + value, { type: 'checkName' })
            .then(response => {
                if (response.data === 'duplicate') {
                    console.log("response", response.data)
                    return "Duplicate"
                }
            })
            .catch(error => "")
}

export const searchColumns = [
    {
        Header: <div style={{ textAlign: 'left' }} >PARENT GROUP</div>,
        accessor: 'parent_group',
        Cell: row => <div className='ellipsisDiv' style={{ width: '150px',paddingLeft: "8px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'ledgerfilter1',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >LEDGER TYPE</div>,
        accessor: 'ledger_type',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }} title={(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'ledgerfilter2',

    },
    {
        Header: <div style={{ textAlign: 'left' }} >DMS NAME</div>,
        accessor: 'dms_name',
        Cell: row => <div className='ellipsisDiv' style={{ textAlign: "left", paddingLeft: "5px", width: '90%' }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'ledgerfilter3'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >RLB NAME</div>,
        accessor: 'rlb_name',
        Cell: row => <div className='ellipsisDiv' style={{ textAlign: "left", paddingLeft: "5px", width: '90%' }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'ledgerfilter4'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >DMS: LEDGER ID</div>,
        accessor: 'dms_id',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px" }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'ledgerfilter5'
    },
    {
        Header: <div style={{ textAlign: 'left' }} >RealBooks: LEDGER ID</div>,
        accessor: 'rlb_id',
        Cell: row => <div style={{ textAlign: "left", paddingLeft: "5px", }}>{(row.value && row.value !== undefined && row.value !== null && row.value !== 'NULL' && row.value !== "0" && row.value !== 0) ? row.value : ""}</div>,
        classNameGet: 'ledgerfilter6'
    },

]